/* eslint-disable react/prop-types */
import { useState } from "react";
import { motion } from "framer-motion";
import { IMAGE_URL } from "../../../constants";

const FeatureCard = ({ title, description, image, index, primaryColor }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, rotateY: -30, translateZ: -100 }}
        whileInView={{ opacity: 1, rotateY: 0, translateZ: 0 }}
        whileHover={{ scale: 1.05, rotateY: 5, translateZ: 20 }}
        viewport={{ once: true }}
        transition={{
          duration: 0.8,
          delay: index * 0.2,
          type: "spring",
          stiffness: 100,
        }}
        style={{ perspective: "1000px", transformStyle: "preserve-3d" }}
        className="relative h-full group"
      >
        <div
          className="relative cursor-pointer h-full bg-white/80 backdrop-blur-lg rounded-2xl p-8 shadow-[0_8px_32px_rgba(0,0,0,0.1)] 
          border border-white/20 hover:shadow-[0_16px_48px_rgba(0,0,0,0.2)] transition-all duration-500"
        >
          {/* Glow effect */}
          <div
            className="absolute inset-0 transition-opacity duration-500 opacity-0 rounded-2xl group-hover:opacity-100"
            style={{
              background: `linear-gradient(135deg, ${primaryColor}80, ${primaryColor}30)`,
            }}
          />

          <div className="relative z-10">
            {/* Icon container with floating animation */}
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
              className="inline-flex p-4 mb-6 rounded-2xl"
              style={{
                background: `linear-gradient(135deg, ${primaryColor}20, ${primaryColor}30)`,
              }}
            >
              <img
                src={`${IMAGE_URL}/${image}`}
                alt={title}
                className="max-w-10"
              />
            </motion.div>

            <h3 className="mb-4 text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-gray-900 to-gray-600">
              {title}
            </h3>

            <p className="line-clamp-4">{description}</p>

            {/* See More button */}
            {description.split(" ").length > 50 && ( // crude check for long description
              <button
                onClick={() => setIsModalOpen(true)}
                className="mt-2 text-blue-600 hover:underline"
              >
                See More
              </button>
            )}
          </div>
        </div>
      </motion.div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
          <div className="bg-white rounded-2xl p-8 max-w-lg w-full relative">
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-800 font-bold"
            >
              ✕
            </button>
            <h3 className="mb-4 text-2xl font-bold">{title}</h3>
            <p>{description}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default FeatureCard;
